import { Component, ElementRef } from '@angular/core';
import { DataInitialValueServiceService } from 'app/modules/core/services/data-initial-value-service.service';
import { MicroescapesConfiguration } from './models/microescapes-config.model';

@Component({
  selector: 'app-microescapes-container',
  templateUrl: './templates/microescapes-container.component.html'
})
export class MicroescapesContainerComponent {
  config: MicroescapesConfiguration;
  constructor(
    private elementRef: ElementRef,
    private dataInitialValue: DataInitialValueServiceService
  ) {
    this.config = this.dataInitialValue.Parse<MicroescapesConfiguration>(
      this.elementRef
    );
  }
}
